<template>
  <v-container>
    <v-row justify="space-between">
      <v-col
        cols="12" sm="6" md="8" lg="9"
        class="d-flex align-center title text-uppercase primary--text"
      >
        Permissions
      </v-col>
      <v-col cols="12" sm="6" md="4" lg="3">
        <v-btn @click="openPermissionEditor('create')" block color="primary">
          {{ $t('actions.create') }}
        </v-btn>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <v-card>
          <v-data-table
            :headers="permissionsTable.headers"
            :items="permissions"
            :loading="permissionsTable.loading"
            item-key="id"
            :page="permissionsPagination.page"
            :server-items-length="permissionsPagination.total"
            :footer-props="{
              itemsPerPageOptions: permissionsTable.itemsPerPageOptions
            }"
            @pagination="setPagination"
          >
            <template v-slot:item.name="{ item }">
              <div class="font-weight-bold">
                {{ item.name }}
              </div>
              <div class="text-gray">
                {{ item.is_admin ? 'Admin' : 'General' }}
              </div>
            </template>
            <template v-slot:item.action="{ item }">
              <v-menu
                left
                offset-y
                nudge-bottom="10"
                transition="slide-y-transition"
                min-width="180px"
              >
                <template v-slot:activator="{ on }">
                  <v-btn v-on="on" icon>
                    <v-icon>more_vert</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item @click="openPermissionEditor('detail', item.id)">
                    Detalles
                  </v-list-item>
                  <v-list-item @click="openPermissionEditor('edit', item.id)">
                    Editar
                  </v-list-item>
                  <v-list-item @click="openPermissionRemove(item.id)">
                    Eliminar
                  </v-list-item>
                </v-list>
              </v-menu>
            </template>
            <template v-slot:no-data>
              <div class="text-center pa-12">
                <v-img
                  :src="require('@/assets/svg/box_empty.svg')"
                  height="150"
                  max-height="150px"
                  aspect-ratio="1"
                  contain
                />
                <div class="grey--text">
                  {{ $t('common.no_results_found') }}
                </div>
              </div>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>
    <PermissionEditor />
    <PermissionRemove />
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import PermissionEditor from '@/components/Permissions/Editor'
import PermissionRemove from '@/components/Permissions/Remove'
export default {
  components: {
    PermissionEditor,
    PermissionRemove
  },
  data () {
    return {
      permissionsTable: {
        loading: false,
        headers: [
          {
            text: 'ID',
            value: 'id',
            align: 'end',
            class: 'blue--text text--darken-4 text-right text-no-wrap',
            width: '0'
          },
          {
            text: 'Name',
            value: 'name',
            align: 'start',
            class: 'blue--text text--darken-4 text-right text-no-wrap',
            width: ''
          },
          {
            text: 'Description',
            value: 'description',
            align: 'start',
            class: 'blue--text text--darken-4 text-right text-no-wrap',
            width: ''
          },
          {
            text: '',
            value: 'action',
            align: 'center',
            class: '',
            sortable: false,
            width: '0'
          }
        ],
        itemsPerPageOptions: [
          { value: 5, text: 5 },
          { value: 10, text: 10 },
          { value: 15, text: 15 },
          { value: 25, text: 25 },
          { value: 100, text: 100 }
        ],
        items: [],
        pagination: {}
      }
    }
  },
  computed: {
    ...mapGetters({
      permissions: 'permissions/permissions',
      permissionsPagination: 'permissions/permissionsPagination',
      updateRequired: 'permissions/updateRequired'
    })
  },
  watch: {
    updateRequired (newVal) {
      if (newVal) {
        this.getData()
      }
    }
  },
  created () {
    // this.getData()
  },
  destroyed () {
    this.resetState()
  },
  methods: {
    ...mapActions({
      resetState: 'permissions/resetState',
      getPermissions: 'permissions/getPermissions',
      getPermission: 'permissions/getPermission'
    }),
    ...mapMutations({
      toggleUpdateRequired: 'permissions/toggleUpdateRequired',
      togglePermissionEditor: 'permissions/togglePermissionEditor',
      togglePermissionRemove: 'permissions/togglePermissionRemove',
      setPermissionEditorMode: 'permissions/setPermissionEditorMode',
      setPermissionsPagination: 'permissions/setPermissionsPagination'
    }),
    async getData () {
      const {
        limit,
        offset
      } = this.permissionsPagination
      this.permissionsTable.loading = true
      await this.getPermissions({
        limit,
        offset,
        count: 'permissions'
      })
      this.permissionsTable.loading = false
    },
    setPagination (pagination) {
      const {
        itemsPerPage,
        page
      } = pagination
      this.setPermissionsPagination({
        ...this.permissionsPagination,
        limit: itemsPerPage,
        offset: page
      })
      this.getData()
    },
    async openPermissionEditor (mode = 'create', id) {
      if (['edit', 'detail'].includes(mode)) {
        await this.getPermission({ id })
      }
      this.setPermissionEditorMode(mode)
      this.togglePermissionEditor(true)
    },
    async openPermissionRemove (id) {
      await this.getPermission({ id })
      this.togglePermissionRemove(true)
    }
  }
}
</script>
